$(document).ready(function () {
  // ************* utility **************************
  $('.js-prevent-default').click(function (e) {
    event.preventDefault();
    // console.log("click registered");
    return;
  })


  // ************* header **************************


  // check if promo-banner is present, return height of banner or zero
  var topBannerHeight = $('.announcement-bar').length ? $('.announcement-bar').outerHeight() : 0;
  var $initialLogo = $(".header-layout");
  var $scrollLogo = $("#scroll-logo");
  var $navIcons = $(".header-item.header-item--icons");
  var $cartLogo = $(".scroll-cart");
  var heightOfInitialLogo = $initialLogo.outerHeight() + topBannerHeight + 100;
  var isScrolledLogoDisplayed = false;


  // monitors the scroll position of the page to show 'return-to-top' button
  function checkScroll() {
    // the curent y-axis value
    var scrollYAxisValue = window.scrollY;
    var isMobile = document.body.clientWidth < 768;

    if (scrollYAxisValue >= heightOfInitialLogo && !isScrolledLogoDisplayed && !isMobile) {
      toggleScrolledLogo();
    } else if (scrollYAxisValue < heightOfInitialLogo && isScrolledLogoDisplayed && !isMobile) {
      toggleScrolledLogo();
    }
  }

  function toggleScrolledLogo() {
    if (!isScrolledLogoDisplayed) {
      $scrollLogo.css("opacity", 1);
      $cartLogo.css("opacity", 1);
      $cartLogo.css("display", "block");
      $navIcons.css("opacity", 0);
    } else {
      $scrollLogo.css("opacity", 0);
      $cartLogo.css("opacity", 0);
      $navIcons.css("opacity", 1);
      setTimeout(function(){ $cartLogo.css("display", "none"); }, 700);
    }
    isScrolledLogoDisplayed = !isScrolledLogoDisplayed;
  }

  

  var scrollTimeout;
  //scroll event throttler to stop the browser from overworking
  function scrollThrottler() {
    // ignore scroll events as long as an checkScroll execution is in the queue
    if (!scrollTimeout) {
      scrollTimeout = setTimeout(function () {
        scrollTimeout = null;
        checkScroll();
        // The checkScroll will execute at a rate of 
      }, 200);
    }
  }

  // create scroll event listener
  $(window).scroll(scrollThrottler);



  // ****   for interactive content section ****
  // ------------------------------------------ // -------------------------------------- // ----------------------
  // see snippet/product-additional-info-smoker.liquid for section architecture

  // listen for click on details section heading on desktop
  $('.js-details-heading').click(function () {
    // get the specific section name for this deatils block
    let specificSection = $(this).closest('[data-specific-section]').data('specific-section');
    let sectionNumber = $(this).data('section');

    // toggle the classes on the desktop details header
    $('[data-specific-section="' + specificSection + '"] .js-details-heading').removeClass('js-details-heading-active');
    $('[data-specific-section="' + specificSection + '"] .js-details-heading[data-section="' + sectionNumber + '"').addClass('js-details-heading-active');

    // reveal the desired section
    $('[data-specific-section="' + specificSection + '"] .js-details-section').removeClass('js-details-section-active');
    $('[data-specific-section="' + specificSection + '"] .js-details-section[data-section="' + sectionNumber + '"').addClass('js-details-section-active');

  });
  // listen for click on details section heading on mobile headers
  $('.js-details-heading-mobile').click(function () {
    // get the specific section name for this deatils block
    let specificSection = $(this).closest('[data-specific-section]').data('specific-section');
    let sectionNumber = $(this).data('section');
    if ($('[data-specific-section="' + specificSection + '"] .js-details-section[data-section="' + sectionNumber + '"').hasClass('js-details-section-active-mobile')) {
      $('[data-specific-section="' + specificSection + '"] .js-details-heading-mobile[data-section="' + sectionNumber + '"').removeClass('js-details-heading-mobile-active');
      $('[data-specific-section="' + specificSection + '"] .js-details-section[data-section="' + sectionNumber + '"').removeClass('js-details-section-active-mobile');
      $('[data-specific-section="' + specificSection + '"] .js-details-heading-mobile.js-character-switch').children('span').text('+');
    } else {
      $('[data-specific-section="' + specificSection + '"] .js-details-section[data-section="' + sectionNumber + '"').addClass('js-details-section-active-mobile');
      $('[data-specific-section="' + specificSection + '"] .js-details-heading-mobile[data-section="' + sectionNumber + '"').addClass('js-details-heading-mobile-active');
      $('[data-specific-section="' + specificSection + '"] .js-details-heading-mobile.js-character-switch[data-section="' + sectionNumber + '"').children('span').text('-');
    }

    if ($(this).hasClass('js-character-switch')) {
      $("body,html").animate({
        scrollTop: $('[data-specific-section="' + specificSection + '"] .js-details-heading-mobile.js-character-switch[data-section="' + sectionNumber + '"').offset().top - ($('header.site-header').height() + 40)
      }, 0);
    }

  });


  // ------------------------------------------ // -------------------------------------- //---------------------- Read More ------------


  if ($('.js-read-more'.length > 0)) {
    $('.js-read-more').click(function () {
      $(this).css("display", "none");
      $('.read-more-hidden').removeClass('read-more-hidden');
    });
  }

  // ------------------------------------------ // -------------------------------------- //---------------------- Carousels ------------

  if ($('.js-carousel').length > 0) {
    $('.js-carousel').slick();
  }

  if ($('.js-carousel-small-mob-2').length > 0) {
    $('.js-carousel-small-mob-2').slick({
      slidesToShow: 2,
      arrows: false,
      dots: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  }

  if ($('.js-carousel-small-mob-3').length > 0) {
    $('.js-carousel-small-mob-3').slick({
      slidesToShow: 3,
      arrows: false,
      dots: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  }

  if ($('.js-carousel-small-mob-4').length > 0) {
    $('.js-carousel-small-mob-4').slick({
      slidesToShow: 4,
      arrows: false,
      dots: true,
      responsive: [{
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }]
    });
  }

  // ----------------------------------// recipe additional images carousel // -----------
  if ($('.recipe-carousel').length > 0) {
    var carouselOptions = {
      dots: true,
      infinite: true,
      slidesToShow: 1,
      arrows: false
    }
    $(".recipe-carousel").slick(carouselOptions);
  }



  // ----------------------------------// blog article search mothod section // -----------


  if ($('.js-search-method').length > 0) {
    var searchMethodTab = $('.js-search-method h4');
    var searchMethod = $('.js-search-or-catagory');
    searchMethodTab.click(function () {
      searchMethodTab.removeClass('js-search-method-active');
      $(this).addClass('js-search-method-active');
      searchMethod.removeClass('js-search-or-catagory-active');
      var nextSection = $(this).data('section');
      $('.js-search-or-catagory[data-section="' + nextSection + '"]').addClass('js-search-or-catagory-active');
    });
  }


  // ------------------------------------// article cards // ---------

  if ($('.js-article-card-heading').length > 0) {
    var heading = $('.js-article-card-heading');
    var cards = $('.js-article-card');
    heading.click(function () {
      heading.removeClass('js-article-card-heading-active');
      $(this).addClass('js-article-card-heading-active');
      cards.removeClass('js-article-card-active');
      var nextSection = $(this).data('section');
      $('.js-article-card[data-section="' + nextSection + '"]').addClass('js-article-card-active');
    });
  }


  // ----------------------------------// tasting notes // -----------

  if ($('[data-wood-checkbox]').length > 0) {
    var wood;
    // Highlight on page load - though already handled in liquid #beltsAndBraces
    $('[data-wood-checkbox]:checked').each(function () {
      wood = $(this).data('wood-checkbox');
      $('.tasting-note').hide();
      $('#tasting-note-' + wood).show();
    });
    $('[data-wood-checkbox]').change(function () {
      if (this.checked) {
        wood = $(this).data('wood-checkbox');
        $('.tasting-note').hide();
        $('#tasting-note-' + wood).show();
      }
    });
  }

  // ------------------------------------// smoker product features tooltips // ---------

  if ($('.js-tool-tip').length > 0) {
    var tipIcon = $('.js-tool-tip');
    tipIcon.click(function () {
      $('.feature-text').removeClass('feature-text-active');
      let section = $(this).data("feature");
      $('.feature-text[data-feature="' + section + '"]').toggleClass('feature-text-active');
    });
    $('.feature-text').click(function () {
      $('.feature-text').removeClass('feature-text-active');
    });
  }

  // ------------------------------------// contact form // ---------

  if ($('#contact_form').length > 0) {
    var $myForm = $('#contact_form');
    var $nameInput, $emailInput, $textInput, pass;
    var emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    $myForm.submit(function () {

      $nameInput = $('input[name="contact[name]"').val();
      $emailInput = $('input[name="contact[email]"').val();
      $textInput = $('textarea[name="contact[body]"').val();

      if ($nameInput !== "" && $emailInput !== "" && $textInput !== "") {
        $('.js-form-alert').css("display", "none");
        pass = emailReg.test(String($emailInput).toLowerCase());
        if (pass) {
          return true;
        }

      } else if ($nameInput === "" || $emailInput === "" || $textInput === "") {

        $('.js-form-alert').css("display", "block");
        $('input[name="contact[name]"').css("border", "1px solid #FA4616");
        $('input[name="contact[email]"').css("border", "1px solid #FA4616");
        $('textarea[name="contact[body]"').css("border", "1px solid #FA4616");
        return false;

      }
    });
  };
  // ------------------------------------// Account sign-up// ---------

  if ($('#create_customer').length > 0) {
    var $newAccountForm = $('#create_customer');
    var $passwordConfirmInputValue, $passwordInputValue;

    $newAccountForm.submit(function () {

      $passwordInputValue = $('input[name="customer[password]"').val();
      $passwordConfirmInputValue = $('#ConfirmPassword').val();

      if ($passwordInputValue === $passwordConfirmInputValue) {
        $('.js-hidden-alert').css("display", "none");
        return true;

      } else {
        $('.js-hidden-alert').css("display", "block");
        $('#ConfirmPassword').css("border", "1px solid #FA4616");
        $('input[name="customer[password]"').css("border", "1px solid #FA4616");
        return false;

      }
    });
  };
  // ------------------------------------// Site Select Dropdown // ---------

  $('.each-choice').click(siteChoice);
  $('.js-site-select').click(multiSiteSelect);

  function multiSiteSelect(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    toggleDropDown();
    return;
  }

  function toggleDropDown() {
    var $siteSelectDropdown = $('.site-select-dropdown');
    if ($siteSelectDropdown.hasClass('isVisible')) {
      hideDropDown($siteSelectDropdown);
    } else {
      showDropDown($siteSelectDropdown);
    }
    return;
  }

  function hideDropDown(el) {
    el.removeClass('isVisible');
    turnOffExitClick();
    return;
  }

  function showDropDown(el) {
    el.addClass('isVisible');
    setUpExitClick(el);
    return;
  }

  function setUpExitClick(el) {
    $(document).on('click', function (event) {
      //if you click on anything except the dropdown itself or the "open modal" link, close the modal
      if (!$(event.target).closest('.site-select-dropdown').length) {
        hideDropDown(el);
      }
      return;
    });
    return;
  }

  function turnOffExitClick() {
    $(document).off('click');
    return;
  }

  function siteChoice(event) {
    // stop the click registering on it's parent <a> tag
    event.stopPropagation();
    event.preventDefault();

    var url = $(this).data('link');
    if (url === 'this-site') {
      toggleDropDown();
    } else {
      window.location.href = url;
    }
    return;
  }

});